import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfirmationDialogue } from '../../providers/ConfirmationDialogue.provider';

import type { PartnerInvoicesResponse } from '../useApi/useFetchPartnerInvoices';

const usePartnerInvoicesDialogue = (response?: PartnerInvoicesResponse): { showDialogue: () => void } => {
  const errorMessage = response?.errorMessage || '';

  const { t } = useTranslation('translations', { keyPrefix: 'Hooks.UsePartnerInvoicesDialogue' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { provideProps, showDialogue } = useConfirmationDialogue();

  useEffect(() => {
    const handlers = {
      errorMessage: () => {
        provideProps({
          title: t('errorTitle', { defaultValue: 'Error! There is a problem with the submitted parameters.' }),
          subTitle: errorMessage,
          status: 'error',
          confirm: {
            label: tGlobal('Buttons.stayHereAndTryAgain'),
            action: () => {},
          },
        });
      },
    };

    if (errorMessage) return handlers.errorMessage();

    return handlers.errorMessage();
  }, [errorMessage]);

  return { showDialogue };
};

export default usePartnerInvoicesDialogue;
